import React from 'react'
import { useTranslation } from 'react-i18next'

import { Button } from '../../../../../Common/Button'

export const DeleteButtons = () => {
  const { t } = useTranslation()

  return (
    <Button color="white" bg="error" type="submit">
      {t('Delete')}
    </Button>
  )
}
